var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 436,
    viewBox: "0 0 512 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_2016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.714 436C416.049 436 457.143 401.007 457.143 358.142L457.143 77.8567C457.143 34.9933 416.05 -0.000831604 365.714 -0.000831604L146.285 -0.000831604C95.9501 -0.000831604 54.856 34.9924 54.856 77.8567L54.856 358.142C54.857 401.007 95.9511 436 146.286 436L365.714 436ZM365.714 404.858L146.285 404.858C115.578 404.858 91.4281 384.292 91.4281 358.143L91.4281 77.8575C91.4281 51.7086 115.578 31.1433 146.285 31.1433L365.714 31.1433C396.421 31.1433 420.571 51.7086 420.571 77.8575L420.571 358.142C420.571 384.292 396.421 404.858 365.714 404.858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.571 109C302.67 109 310.857 102.028 310.857 93.4283C310.857 84.8284 302.67 77.8567 292.571 77.8567L219.428 77.8567C209.329 77.8567 201.142 84.8284 201.142 93.4283C201.142 102.028 209.33 109 219.429 109L292.571 109Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_2016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 436,
    fill: "white",
    transform: "matrix(-1 0 0 -1 512 436)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.9f3bb67282649818f691ff50daf4e647.svg";
export { ForwardRef as ReactComponent };